export default function HeroSection() {
  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20warm%20artistic%20abstract%20composition%20with%20soft%20coral%20pink%20and%20golden%20amber%20gradients%2C%20flowing%20curves%20and%20organic%20shapes%2C%20subtle%20manga%20ink%20splash%20textures%20in%20background%2C%20elegant%20and%20modern%20with%20warm%20atmospheric%20lighting%2C%20clean%20minimal%20aesthetic%2C%20digital%20art%20style%20with%20soft%20focus%20edges&width=1800&height=900&seq=hero-bg-comic-2026&orientation=landscape"
          alt="羞羞歪歪漫画背景"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-foreground-950/55 via-foreground-950/35 to-foreground-950/50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-28">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-500/20 text-primary-400 text-sm font-medium mb-6 whitespace-nowrap">
              每日更新 · 竖屏阅读
            </span>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading text-background-50 leading-tight mb-4">
              羞羞歪歪漫画
              <br />
              <span className="text-primary-300">全部章节无删减免费阅读</span>
            </h1>

            <p className="text-lg md:text-xl text-primary-400 font-heading mb-6">
              下拉式阅读，沉浸式体验，随时随地畅享精彩漫画
            </p>

            <p className="text-sm md:text-base text-background-200/80 max-w-xl mx-auto lg:mx-0 mb-8 leading-relaxed">
              羞羞歪歪漫画全集免费阅读平台，收录海量热门漫画资源，全部章节无删减完整呈现。支持下拉式竖屏阅读模式，还原纸质漫画般的沉浸体验。每日同步更新最新章节，在线看入口免费直达，无需注册即可畅读全部内容。当前热门连载持续更新中，热血、恋爱、悬疑、奇幻等多元题材一网打尽。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-accent-400">2000+</div>
                <div className="text-xs text-background-300/80 mt-1">热门漫画资源</div>
              </div>
              <div className="w-px h-10 bg-background-300/30 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-accent-400">每日更新</div>
                <div className="text-xs text-background-300/80 mt-1">同步连载不等待</div>
              </div>
              <div className="w-px h-10 bg-background-300/30 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-accent-400">免费畅读</div>
                <div className="text-xs text-background-300/80 mt-1">全章节无删减</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
              <a
                href="#index"
                onClick={(e) => handleScroll(e, '#index')}
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-full font-medium text-sm transition-all cursor-pointer whitespace-nowrap"
              >
                <i className="ri-book-open-line text-lg"></i>
                开始阅读
              </a>
              <a
                href="#app"
                onClick={(e) => handleScroll(e, '#app')}
                className="inline-flex items-center gap-2 px-8 py-3.5 border border-background-300/60 hover:border-background-200 text-background-200 hover:text-background-50 rounded-full font-medium text-sm transition-all cursor-pointer whitespace-nowrap"
              >
                <i className="ri-smartphone-line text-lg"></i>
                APP下载
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-[280px] sm:w-[320px] md:w-[380px] aspect-[3/4] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20beautiful%20modern%20manga%20style%20illustration%20with%20vibrant%20warm%20coral%20and%20golden%20tones%2C%20dynamic%20composition%20featuring%20a%20stylish%20character%20in%20flowing%20artistic%20lines%2C%20dramatic%20lighting%20with%20soft%20shadows%2C%20elegant%20ink%20wash%20painting%20texture%2C%20contemporary%20comic%20art%20with%20traditional%20Chinese%20aesthetics%2C%20clean%20warm%20background%20with%20subtle%20pattern%20details&width=800&height=1100&seq=hero-comic-cover-2026&orientation=portrait"
                alt="羞羞歪歪漫画主视觉"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 rounded-2xl ring-1 ring-inset ring-background-300/20"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}